import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../utils/api';

const BeritaPage = () => {
  const [berita, setBerita] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try { const res = await api.get('/berita'); setBerita(res.data.data); } catch (e) { console.error(e); } finally { setLoading(false); }
    };
    load();
  }, []);

  if (loading) return <div className="loading-spinner" style={{ minHeight: '100vh', paddingTop: 200 }}><div className="spinner" /></div>;

  return (
    <div style={{ paddingTop: 100, minHeight: '100vh' }}>
      <div className="container-wide">
        <div style={{ marginBottom: '2rem' }}>
          <h1 style={{ fontSize: 'clamp(1.5rem, 3vw, 2.2rem)', marginBottom: '0.5rem' }}>Berita & Informasi</h1>
          <p style={{ color: 'var(--gray-500)' }}>Perkembangan terbaru seputar data dan pembangunan Kabupaten Ngada</p>
        </div>
        {berita.length === 0 ? (
          <div className="empty-state"><div className="empty-icon">📰</div><h3>Belum ada berita</h3></div>
        ) : (
          <div className="berita-grid">
            {berita.map(b => (
              <Link to={`/berita/${b._id}`} key={b._id} className="berita-card">
                <div className="berita-img" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                  {b.gambar ? (
                    <img src={b.gambar} alt={b.judul} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  ) : (
                    <span style={{ color: 'rgba(255,255,255,0.2)', fontSize: '2.5rem', fontFamily: 'var(--font-display)', fontWeight: 800 }}>NGADHU</span>
                  )}
                </div>
                <div className="berita-body">
                  <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '0.5rem' }}>
                    <span className="badge badge-info">{b.kategori}</span>
                  </div>
                  <div className="berita-date">{new Date(b.createdAt).toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' })}</div>
                  <h4>{b.judul}</h4>
                  <p>{b.ringkasan}</p>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default BeritaPage;
